import React from 'react';
import img from './data/img.jpg'
import './Info.css';

const Info = () => {
    return (
        
            <div className="information">
            <img alt="information_image" src={img}/>

            <div className="information_info">
                <p className="information_name">I'm not a programmer</p>
                <p className="information_description">
                     But I really love to discover new things, to understand them. It is wonderful to teach, to learn, inspire others, share knowledge, solve problems and get to know new people.
                </p> 
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/jkunciene" className="information_button mb-2" >Find me on <i class="fab fa-github"></i></a>               
                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/jolita-kuncien%C4%97-8a0402177/" className="information_button" >Find me on <i class="fab fa-linkedin"></i></a>
            </div>
        </div>
        
    )
}

export default Info
